import LoaderWrapper from "@components/LoaderWrapper";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";

const ProtectedRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { authToken, isRetrieveTokenLoading } = useSelector(
    (state) => state.auth
  );

  // Introduce a local state to manage the initial loading state

  useEffect(() => {
    if (!isRetrieveTokenLoading) {
      setIsLoading(false);
    }
  }, [isRetrieveTokenLoading]);

  if (isLoading || isRetrieveTokenLoading) {
    // Show loading state until we're sure the token retrieval process has completed
    return <LoaderWrapper />;
  } else {
    // Once loading is complete, proceed with the usual authToken check
    return authToken ? children : <Navigate to="/signin" replace />;
  }
};

export default ProtectedRoute;
